/**
 * Duration presets for long-form Program formats (Burning Issue, TCR, World News).
 *
 * The word count for each tier is derived from the production rule these formats
 * actually follow: one Voice Over segment per minute of target duration, each
 * segment 10-12 full sentences (~140-170 words at natural Telugu broadcast pace),
 * plus a proportional share of anchor/transition/front-matter content on top.
 * Values are sent to the backend as `duration` (minutes) and `wordCount` (words)
 * — see ContentGenerationService.generateContent(), which turns wordCount into a
 * token budget and continuation-loop stop condition, and PromptEngineer.buildPrompt(),
 * which surfaces both as "Target duration: X minutes" / "Target word count: Y words"
 * in the prompt.
 */

export const PROGRAM_DURATION_PRESETS = [
  { minutes: 5,  words: 1000, label: '5 min (1000+ words)' },
  { minutes: 10, words: 1900, label: '10 min (1900+ words)' },
  { minutes: 15, words: 2700, label: '15 min (2700+ words)' },
  { minutes: 20, words: 3500, label: '20 min (3500+ words)' },
  { minutes: 25, words: 4300, label: '25 min (4300+ words)' },
  { minutes: 30, words: 5200, label: '30 min (5200+ words)' },
  { minutes: 45, words: 7700, label: '45 min (7700+ words)' },
];

export const DEFAULT_PROGRAM_DURATION_MINUTES = 15;
